import CommonRoutes from "./CommonRoutes";
//CEO
import ExecutiveRoutes from "./CEO/ExecutiveRoutes";
//CORPORATE RESOURCE
import FinanceRoutes from "./CorporateResource/FinanceRoutes";
import CorporateReourceHeadRoutes from "./CorporateResource/CorporateReourceHeadRoutes";
import CorporateResourceMangDevRoutes from "./CorporateResource/CorporateResourceMangDevRoutes";

//EIC
import EICRoutes from "./EIC/EICRoutes";
import EICHeadRoutes from "./EIC/EICHeadRoutes";
//LAND AND INFRASTRUCTURE
import {
  DesignConstructionRoutes,
  GISRoutes,
  LandAndInfraDevelopmentHeadRoutes,
  MPandLBHeadRoutes,
} from "./LandAndInfrastructure";
//OPERATION AND MANAGEMENT
import OperationManagementHeadRoutes from "./OperationManagement/OperationManagementHeadRoutes";
import InvestorAftercareRoutes from "./OperationManagement/InvestorAftercareRoutes";
import InvestorAftercareHeadRoutes from "./OperationManagement/InvestorAftercareHeadRoutes";
//PARK
import ParkStaffRoutes from "./Park/ParkStaffRoutes";
import ParkAdminRoutes from "./Park/ParkAdminRoutes";
//PROMOTION AND MARKETING
import PromotionAndMarketingRoutes from "./PromotionAndMarketing/PromotionAndMarketingRoutes";
import InvestmentPromotionAndMarkDivRoutes from "./PromotionAndMarketing/InvestmentPromotionAndMarkDivRoutes";


//SYSTEM ADMIN
import SystemAdminRoutes from "./SystemAdmin/SystemAdminRoutes";
import SystemAdminHeadRoutes from "./SystemAdmin/SystemAdminHeadRoutes";

export {
  CommonRoutes,
  ExecutiveRoutes,
  //CORPORATE RESOURCE
  FinanceRoutes,
  CorporateReourceHeadRoutes,
  CorporateResourceMangDevRoutes,
  //EIC
  EICRoutes,
  EICHeadRoutes,
  //LAND AND INFRASTRUCTURE
  DesignConstructionRoutes,
  GISRoutes,
  LandAndInfraDevelopmentHeadRoutes,
  MPandLBHeadRoutes,
  //OPERATION AND MANAGEMENT
  OperationManagementHeadRoutes,
  InvestorAftercareRoutes,
  InvestorAftercareHeadRoutes,
  //PARK
  ParkStaffRoutes,
  ParkAdminRoutes,
  //PROMOTION AND MARKETING
  PromotionAndMarketingRoutes,
  InvestmentPromotionAndMarkDivRoutes,
  //SYSTEM ADMIN
  SystemAdminRoutes,
  SystemAdminHeadRoutes,
};
